import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizzes: [],
  answers: {},
  editing: {
    editMode: false,
    quizId: ""
}
};

const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    startQuiz: (state, action) => {
      state.quizzes = action.payload;
      state.answers = {};

      action.payload.forEach((quiz) => {
        state.answers[`quiz_${quiz.id}`] = [];
      });
    },
    toggleAnswer: (state, action) => {
      const { quizId, option } = action.payload;
      const selectedOptions = state.answers[`quiz_${quizId}`] || [];

      const isOptionExist = selectedOptions.find(
        (selectedOption) => selectedOption.id === option.id
      );
      if (isOptionExist) {
        state.answers[`quiz_${quizId}`] = selectedOptions.filter(
          (selectedOption) => selectedOption.id !== option.id
        );
      } else {
        state.answers[`quiz_${quizId}`] = [...selectedOptions, option];
      }
    },
    startEditing: (state, action) => {
      state.editing.quizId = action.payload
      state.editing.editMode = true
    },
    closeEditing: (state, action) => {
      state.editing.quizId = "";
      state.editing.editMode = false;
    }
  },
});

export const { startQuiz, toggleAnswer, startEditing, closeEditing } = quizSlice.actions;
export default quizSlice.reducer;
